import { render, staticRenderFns } from "./UISnackbar.vue?vue&type=template&id=0427d0ac&"
import script from "./UISnackbar.vue?vue&type=script&lang=js&"
export * from "./UISnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports